import { WAREHOUSE_LOAD, WAREHOUSE_LOAD_SUCCESS, WAREHOUSE_LOAD_FAIL } from '../actions/driverTypes.js';
import { PARCEL_RETURN_REFERENCE_LOAD, PARCEL_RETURN_REFERENCE_LOAD_SUCCESS, PARCEL_RETURN_REFERENCE_LOAD_FAIL } from '../actions/driverTypes.js';
import { ADD_PARCEL_RETURN, ADD_PARCEL_RETURN_SUCCESS, ADD_PARCEL_RETURN_FAIL } from '../actions/driverTypes.js';

import _ from 'lodash'

const initialState = {
    warehouseInfoError: false,
    parcelReferError: false,

    warehouseList: [],

    parcelBatchNo: "",
    parcelTotal:0,
    parcelScanStartNo:0,

    scanResult: {},
    addParcelRtnStatus: "",   
    addParcelRtnRetMsg: "",
    addParcelRtnError: false,

    // fromPage: 1,
    // lastPage: 1,
    // pageSize: 10,
    pageTotal: 0,
    
}

export default function parcelReturnReducer(state = initialState, action) {
    switch(action.type) {
        case WAREHOUSE_LOAD:
            return {
                ...state,
                warehouseInfoError: false,            
            }
        case WAREHOUSE_LOAD_SUCCESS:
            return {
                ...state,
                warehouseList: action.payload.data.warehouses,
                warehouseInfoError: false,
            }
        case WAREHOUSE_LOAD_FAIL:
            return {
                ...state,
                warehouseInfoError: true,
            }    
        case PARCEL_RETURN_REFERENCE_LOAD:
            return {
                ...state,
                parcelReferError: false,            
            }
        case PARCEL_RETURN_REFERENCE_LOAD_SUCCESS:
            return {
                ...state,
                parcelBatchNo: action.payload.data.batch,  
                parcelTotal: action.payload.data.total,  
                parcelScanStartNo: action.payload.data.next,
                parcelReferError: false,
            }
        case PARCEL_RETURN_REFERENCE_LOAD_FAIL:
            return {
                ...state,
                parcelReferError: true,
            }                
        case ADD_PARCEL_RETURN:
            return {
                ...state,                
                scanResult: {},
                addParcelRtnStatus: "",     
                addParcelRtnRetMsg: "",
                addParcelRtnError: false,                       
            }
        case ADD_PARCEL_RETURN_SUCCESS:
            return {
                ...state,
                scanResult: action.payload.data,
                addParcelRtnStatus: action.payload.status, 
                addParcelRtnRetMsg: action.payload.ret_msg,
                addParcelRtnError: false,     
            }
        case ADD_PARCEL_RETURN_FAIL:
            return {
                ...state,
                scanResult: action.payload.data, 
                addParcelRtnStatus: action.payload.status, 
                addParcelRtnRetMsg: action.payload.ret_msg,
                addParcelRtnError: true,
            }        
        default: 
            return state
    }
}
